import { render, staticRenderFns } from "./IconesRedesSociais.vue?vue&type=template&id=759a2834&scoped=true"
import script from "./IconesRedesSociais.vue?vue&type=script&lang=ts"
export * from "./IconesRedesSociais.vue?vue&type=script&lang=ts"
import style0 from "./IconesRedesSociais.vue?vue&type=style&index=0&id=759a2834&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "759a2834",
  null
  
)

export default component.exports